import { MijnRoute } from '../../mijn-navigatie.model';

export const INCOME_AND_EXPENSE: MijnRoute = {
    path: 'inkomsten-en-uitgaven',
    navigationEvent: 'toInkomstenUitgaven',
    regex: /^\/inkomsten-en-uitgaven$/,
    webcomponent: 'mijn-geld-inzicht-webcomponent'
};
